import Navigation from "@/components/Navigation";
import { ExternalLink } from "lucide-react";

const MERCH_IMG = "https://customer-assets.emergentagent.com/job_675babbc-b638-4f01-8d2c-ef157b4ed4ab/artifacts/let0ar5m_Masks%20Of%20A%20Burning%20Alien.png";
const DISENGAGED_IMG = "https://customer-assets.emergentagent.com/job_675babbc-b638-4f01-8d2c-ef157b4ed4ab/artifacts/x1h7p8sl_Human%20Suit%20Disengaged.png";

export default function MerchPortal() {
  return (
    <div data-testid="merch-page" className="min-h-screen bg-[#050505] noise-bg">
      <Navigation />

      {/* Header */}
      <div className="p-6 sm:p-10 md:p-16 md:pb-10 max-w-3xl">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-1.5 h-1.5 bg-[#FF3333] sys-pulse" />
          <span className="text-[10px] tracking-[0.25em] text-[#444] uppercase font-bold" style={{ fontFamily: "'Azeret Mono', monospace" }}>
            sys.artifacts // physical_signal_carriers
          </span>
        </div>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter uppercase text-[#E5E5E5]" style={{ fontFamily: "'Azeret Mono', monospace" }}>
          SIGNAL ARTIFACTS
        </h1>
        <p className="text-xs text-[#555] mt-3 max-w-md leading-relaxed">
          physical matter encoded with ABG frequencies. not merch — artifacts. each one carries a signal. some carry hidden ones.
        </p>
      </div>

      {/* Etsy — asymmetric layout */}
      <div className="grid grid-cols-1 md:grid-cols-12 border-t border-white/5">
        <div className="md:col-span-5 relative min-h-[350px] md:min-h-0">
          <img src={MERCH_IMG} alt="" className="w-full h-full object-cover sys-img opacity-75" />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#050505]/20" />
        </div>
        <div className="md:col-span-7 p-8 sm:p-12 md:p-16 flex flex-col justify-center">
          <span className="text-[10px] tracking-[0.25em] text-[#FF3333]/60 uppercase font-bold mb-6" style={{ fontFamily: "'Azeret Mono', monospace" }}>
            sys.portal // external_channel
          </span>
          <h2 className="text-xl sm:text-2xl font-bold tracking-tight uppercase text-[#E5E5E5] mb-4" style={{ fontFamily: "'Azeret Mono', monospace" }}>
            ARTIFACT DISTRIBUTION CHANNEL
          </h2>
          <p className="text-sm text-[#666] leading-relaxed mb-8 max-w-md">
            all physical artifacts are distributed through an external portal. wearable transmissions. things that carry a frequency you can hold in your hands.
          </p>
          <a
            href="https://www.etsy.com/shop/AstralBornGlitch?ref=shop_sugg_market"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="etsy-link"
            className="inline-flex items-center gap-3 border border-white/20 px-8 py-4 text-[10px] tracking-[0.25em] uppercase font-bold text-[#E5E5E5] sys-btn w-fit"
            style={{ fontFamily: "'Azeret Mono', monospace" }}
          >
            ACCESS ARTIFACT PORTAL
            <ExternalLink size={12} />
          </a>
          <p className="text-[9px] text-[#333] mt-3 tracking-[0.1em]">
            &gt; redirect: external signal channel (etsy)
          </p>
        </div>
      </div>

      {/* NFC Section — offset */}
      <div className="border-t border-white/5">
        <div className="grid grid-cols-1 md:grid-cols-12">
          <div className="md:col-span-8 md:col-start-3 p-8 sm:p-12 md:p-16">
            <div className="border border-white/5 p-8 sys-panel">
              <span className="text-[10px] tracking-[0.25em] text-[#FF3333]/60 uppercase font-bold" style={{ fontFamily: "'Azeret Mono', monospace" }}>
                sys.protocol // nfc_embedded_signals
              </span>
              <h3 className="text-lg font-bold tracking-tight uppercase text-[#E5E5E5] mt-4 mb-4" style={{ fontFamily: "'Azeret Mono', monospace" }}>
                HIDDEN FREQUENCIES IN ARTIFACTS
              </h3>
              <div className="space-y-3 text-sm text-[#666] leading-relaxed">
                <p>
                  some artifacts carry embedded NFC signals. scan them — they unlock hidden pages on this site. exclusive transmissions. unreleased material. things that only exist for whoever carries the frequency.
                </p>
                <p className="text-xs text-[#444] pl-4 border-l border-white/5">
                  &gt; each NFC chip contains a unique decryption key<br/>
                  &gt; hidden pages are not indexed or linked anywhere<br/>
                  &gt; if you have the artifact, you have the access
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="border-t border-white/5 p-6 flex items-center justify-between">
        <p className="text-[9px] text-[#333] tracking-[0.15em]" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
          sys.artifacts.end // carrier_integrity = STABLE
        </p>
        <p className="text-[9px] text-[#333]">ABG.</p>
      </footer>
    </div>
  );
}
